// extracted by mini-css-extract-plugin
export default {"v2Pagination":"v2Pagination--_RoEg","total":"total--JW37q","v2PaginationSimpleWithTotal":"v2PaginationSimpleWithTotal--yo_Ko"};